import i18next from 'i18next';

export const renderSubtitle = (element: string) =>
  i18next
    .t(`technicalSheet:${element}`)
    .toString();

export const renderText = (subtitle: string, value: string, translate: boolean = false) => {
  const subtitleDisplay = renderSubtitle(subtitle);
  if (translate) {
    return { subtitle: subtitleDisplay, value: i18next.t(`technicalSheet:${value}`).toString() };
  }
  return { subtitle: subtitleDisplay, value };
};

export const renderMany = (subtitle: string, value: string[], separator: string = ', ') => {
  const subtitleDisplay = renderSubtitle(subtitle);
  return { subtitle: subtitleDisplay, value: value.length ? value.join(separator) : '-' };
};

interface FundingInfo {
  totalInvestment: number | null;
  funding: { fundingType: { name: string } | null; funder: { name: string } | null }[];
}

/** Whether the Acción has anything to show under "Costo y financiamiento": an amount, a funding type or a funder. */
export const hasFundingInfo = ({ totalInvestment, funding }: FundingInfo): boolean =>
  totalInvestment !== null || funding.some(row => row.fundingType || row.funder);
